module.exports = __webpack_public_path__ + "img/5G-02-03.341c25ec.png";